import { DOCUMENT, ɵparseCookieValue as parseCookieValue } from '@angular/common';
import { HttpXsrfTokenExtractor } from '@angular/common/http';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { XSRF_COOKIE_NAME } from '../interceptors/http-xsrf.interceptor';

@Injectable({
  providedIn: 'root'
})
export class HttpXsrfTokenExtractorService implements HttpXsrfTokenExtractor {
  private lastCookieString: string = '';
  private lastToken: string | null = null;

  /**
   * @internal
   */
  parseCount: number = 0;

  constructor(@Inject(DOCUMENT) private readonly doc: any, @Inject(PLATFORM_ID) private readonly platform: string, @Inject(XSRF_COOKIE_NAME) private readonly cookieName: string) {}

  getToken(): string | null {
    if (this.platform === 'server') {
      return null;
    }
    const cookieString = this.doc.cookie || '';
    if (cookieString !== this.lastCookieString) {
      this.parseCount++;
      this.lastToken = parseCookieValue(cookieString, this.cookieName);
      this.lastCookieString = cookieString;
    }
    return this.lastToken;
  }
}
